/**
 * Обёртка над Telegram WebApp.
 *
 * Всё, что приходит из `initDataUnsafe`, — недоверенные данные: клиент может
 * подставить туда что угодно. Наружу отдаётся только сырая `initData`,
 * подпись которой проверяет сервер. Имя и идентификатор женщины приложение
 * получает из ответа сервера, а не отсюда.
 */

interface TelegramWebApp {
  initData: string;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  ready(): void;
  expand(): void;
  close(): void;
  setHeaderColor(color: string): void;
  setBackgroundColor(color: string): void;
  disableVerticalSwipes?(): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function telegram(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function isInsideTelegram(): boolean {
  const app = telegram();
  return Boolean(app && app.initData.length > 0);
}

export function getInitData(): string {
  return telegram()?.initData ?? '';
}

/**
 * Часовой пояс устройства. Telegram его не передаёт, а без него утренняя
 * проверка придёт не в то время — а это единственный принудительный возврат
 * в системе, на нём держится всё удержание.
 */
export function getTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Moscow';
  } catch {
    return 'Europe/Moscow';
  }
}

/** Приложение всегда тёмное: светлой темы в макетах нет. */
export function initTelegramChrome(): void {
  const app = telegram();
  if (!app) return;

  app.ready();
  app.expand();
  // Цвет шапки ставит модуль темы: он знает, светлая она сейчас или тёмная.
  // Свайп вниз внутри прохождения закрывает приложение и теряет шаг.
  app.disableVerticalSwipes?.();
}
